import { defineComponent as _defineComponent } from 'vue'
import routesName from "@/utils/constants/routesName";
import useDayjs from "@/composables/useDayjs";

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  setup(__props, { expose: __expose }) {
  __expose();

const { dayjs } = useDayjs();

const __returned__ = { dayjs, get routesName() { return routesName }, get useDayjs() { return useDayjs } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})